"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RoomCardAtoms_1 = require("../RoomCardAtoms");
const _1 = require(".");
function default_1({ channel_uid, channel_thumbnail, channel_name, isPayform, }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }, { children: [(0, jsx_runtime_1.jsx)(_1.ChannelLink, { channel_uid: channel_uid, channel_thumbnail: channel_thumbnail, channel_name: channel_name }), isPayform && (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.PayformTag, {})] })));
}
exports.default = default_1;
